import "@hotwired/turbo-rails"

import imagesLoaded from 'imagesloaded'
import OpenSeadragon from 'openseadragon/build/openseadragon/openseadragon.min.js'

require("../stylesheets/digitals.scss");

// TODO
//= require openseadragon.min

document.addEventListener('turbo:load', () =>  {

	const math = {
		lerp: (a, b, n) => {
			return (1 - n) * a + n * b
		},
		norm: (value, min, max) => {
				return (value - min) / (max - min)
		},
		map: (x, a, b, c, d) => (x - a) * (d - c) / (b - a) + c
	}

	const config = {
		height: window.innerHeight,
		width: window.innerWidth
	}

	let windowScrollY = 0;

	class Parallax {
		constructor(el) {
			this.image = el
			this.previous = 0
			this.current = 0
			this.ease = 0.05

			this.maxValue = parseInt(this.image.dataset.overflow, 10)
			this.minValue = -1 * this.maxValue;
			if (this.image.dataset.hasOwnProperty("reverse")) {
				this.reverse = true
			} else {
				this.reverse = false
			}

			this.update();
			if ('IntersectionObserver' in window) {
				this.observer = new IntersectionObserver((entries) => {
					entries.forEach(entry => this.isVisible = entry.intersectionRatio > 0);
				});
				this.observer.observe(this.image);
			} else {
				this.isVisible = true;
			}
			
			this.initEvents();
		}
		getValue() {
			return Math.max(Math.min(math.map(this.props.left - windowScrollY, config.width, -1 * this.image.clientWidth, this.minValue, this.maxValue), this.maxValue), this.minValue);
		}
		update() {
			this.getSize();
			this.current = this.previous = this.getValue();
			this.layout();
		}
		getSize() {
			const rect = this.image.getBoundingClientRect();
			this.props = {
				width: rect.width,
				left: window.scrollY + rect.left,
			}
		}
		initEvents() {
			window.addEventListener('resize', () => this.resize());
		}
		resize() {
			this.update();
		}
		render() {
			this.current = this.getValue();
			this.previous = math.lerp(this.previous, this.current, this.ease);
			this.layout();
		}
		layout() {
			if (this.reverse)
				this.image.style.marginLeft = `${this.previous.toFixed(2)}px`
			else 
				this.image.style.marginLeft = `-${this.previous.toFixed(2)}px`
		}
	}

	class Smooth {
		constructor() {
			this.bindAll()
			
			this.el = document.querySelector('div[data-scroll]')
			this.items = this.el.querySelectorAll('.item')

			this.images = [];
			this.el.querySelectorAll('.item__img').forEach(item => {
				this.images.push(new Parallax(item))
			});
			
			this.data = {
				current: 0,
				last: 0,
				on: 0,
				off: 0
			}

			this.bounds = {
				elem: 0,
				content: 0,
				width: 0,
				max: 0,
				min: 0
			}
			
			this.state = {
				dragging: false
			}

			this.rAF = null
			this.parallax = null
			this.init()
		}

		bindAll() {
			['scroll', 'run', 'resize']
			.forEach((fn) => this[fn] = this[fn].bind(this))
		}

		setBounds() {
			let w = 0;
			this.items.forEach((el, index) => {
				const bounds = el.getBoundingClientRect()
				w = w + bounds.width
				
			});
			this.bounds.width = w
			this.bounds.max = this.bounds.width - config.width
			
			this.el.style.width = `${w}px`
			document.body.style.height = `${w}px`
		}

		resize() {
			this.setBounds()
			// this.scroll()
		}

		preload() {
			imagesLoaded(this.el, (instance) => {
				this.on()
			})
		}

		scroll() {
			if (this.state.dragging) return
			this.data.current = windowScrollY = window.scrollY
			this.clamp()
		}
		
		clamp() {
			this.data.current = Math.min(Math.max(this.data.current, 0), this.bounds.max)
		}

		run() {
			this.data.last = math.lerp(this.data.last, this.data.current, 0.085)
			this.data.last = Math.floor(this.data.last * 100) / 100

			for (let i = this.images.length - 1; i >= 0; i--) {
				if (this.images[i].isVisible) {
					this.images[i].render();
				}
			}
			
			// this.images[1].render();

			this.el.style.transform = `translate3d(-${this.data.last.toFixed(2)}px, 0, 0)`
			this.requestAnimationFrame()
		}

		on() { 
			this.setBounds()
			this.addEvents()
			this.requestAnimationFrame()
		}

		requestAnimationFrame() {
			this.rAF = requestAnimationFrame(this.run)
		}

		addEvents() {
			window.addEventListener('scroll', this.scroll, { passive: true })
		}

		init() {
			this.preload()
		}
	}
	
	let smooth = null;
	if ('ontouchstart' in window  || 'onmsgesturechange' in window) {
		//alert("Diese Seite ist erst in einigen Tagen für Touch-Screens optimiert. Bitte nutzen Sie einen Computer;")
	} else {
		smooth = new Smooth()
	}
	
	function getRandomInt(max) {
	  return Math.floor(Math.random() * Math.floor(max));
	}

	document.querySelectorAll('.show_collapsed_button').forEach( (btn) => {
		btn.addEventListener('click', (e)=> {
			const btn = e.target
			const box = document.getElementById(btn.dataset.target)
			if (box.style.display == 'block') {
				box.style.display = 'none';
				btn.classList.remove('active');
			} else {
				box.style.display = 'block';
				btn.classList.add('active')
			}
			smooth.setBounds();
			e.stopPropagation();
		})
	})

	const startImaeg = document.getElementById('start_image')
	if (startImaeg !== null) { startImaeg.style.backgroundImage = `url(/digitals/Start${getRandomInt(8)+1}.jpg)`}
	const audio = document.getElementById('audioplayer')
	const audiostatus = document.getElementById('audiostatus')

	audiostatus.addEventListener('click', () => {
		audio.pause();
		audiostatus.style.display = 'none';
	})

	document.querySelectorAll('.audioicon').forEach( (btn) => {
		btn.addEventListener('click', (e)=> {
			audio.src = btn.dataset.audiosrc
			audiostatus.style.display = "block"
			audio.play()
		});
	});

	audio.addEventListener('ended', () => {
		audiostatus.style.display = 'none'
	});

	document.querySelectorAll('.openfullscreenimageButton').forEach( btn => {
		btn.addEventListener('click', (e)=> {
		const openseadragon = document.getElementById('openseadragon')

		viewer = OpenSeadragon({
			id: "openseadragon",
			showNavigator:  true,
			prefixUrl: 'openseadragon/images/',
			tileSources: `/image-service/${btn.dataset.imageid}/info.json`
		});
		openseadragon.style.height = window.innerHeight + 'px';
		openseadragon.classList.toggle('hidden')
		document.getElementById('hamburger').classList.toggle("change");
		});
	})

	document.getElementById('hamburger').addEventListener('click', (ev) => {
		const imprint = document.getElementById('imprint')
		const openseadragon = document.getElementById('openseadragon')
		
		if (imprint.classList.contains('hidden') == false) {
			imprint.classList.toggle("hidden")
			document.getElementById('imprint_link').classList.toggle('active')
			return
		}
		
		if (openseadragon.classList.contains('hidden') == false) {
			viewer.destroy()
			viewer = null
			const openseadragon = document.getElementById('openseadragon').classList.add('hidden')
			ev.currentTarget.classList.toggle("change");
			return
		}
		
		ev.currentTarget.classList.toggle("change");
		document.getElementById('chapters').classList.toggle("hidden");
	})

	document.getElementById('imprint_link').addEventListener('click', (ev) => {
		const imprint = document.getElementById('imprint')
		imprint.classList.toggle("hidden")
		ev.currentTarget.classList.toggle('active')
	})

	const shareemail = document.getElementById('send_share_email')
	if (shareemail != null) {
		shareemail.addEventListener('click', (ev) => {
			window.location.href = 'mailto:?to=&subject=' + ev.currentTarget.dataset.title +'&body='+ ev.currentTarget.dataset.description + '%0A%0ADetails:%0A' + encodeURIComponent(ev.currentTarget.dataset.link);
		})
	}
});

var viewer = null
